import { Alert, Button, Modal, Table, TableColumnsType } from 'antd';
import { useResponsive } from '~/hooks';
import { PRICING_ITEMS, PRICING_NOTICE, type PricingItem } from '../../pricingData';

const BalanceModal = ({ open, onHideModal }: any) => {
  const { isMobile } = useResponsive();
  const columns: TableColumnsType<PricingItem> = [
    { title: '插件', dataIndex: 'optType' },
    {
      title: '价格',
      dataIndex: 'price',
      render: (text: number, record: PricingItem) => (
        <span>
          {text} 元/{record.unit}
          {record.memberPrices && (
            <div className="text-xs text-gray-400 mt-0.5">
              SVIP {record.memberPrices.svip} 元/{record.unit} · VIP {record.memberPrices.vip} 元/
              {record.unit}
            </div>
          )}
        </span>
      ),
    },
  ];
  return (
    <Modal
      open={open}
      title="计费标准"
      width={isMobile ? 400 : 600}
      onCancel={onHideModal}
      footer={[
        <Button key="cancel" onClick={onHideModal} type="primary">
          知道了
        </Button>,
      ]}
      centered
    >
      <div className="mt-3"></div>
      <Alert message={PRICING_NOTICE} type="info" showIcon />
      <Table<PricingItem>
        size="small"
        className="mt-2"
        columns={columns}
        dataSource={PRICING_ITEMS}
        pagination={false}
      />
    </Modal>
  );
};
export default BalanceModal;
